import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Desktop from './components/Desktop';
import DirectoryPage from './components/DirectoryPage';
import PythonCurriculumPage from './components/PythonCurriculumPage';
import GoCurriculumPage from './components/GoCurriculumPage';
import FamilyLinksPage from './components/FamilyLinksPage';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<DirectoryPage />} />
            <Route path="/portfolio" element={<Desktop />} />
            <Route path="/python-index-curriculum" element={<PythonCurriculumPage />} />
            <Route path="/go-curriculum" element={<GoCurriculumPage />} />
            <Route path="/family-links" element={<FamilyLinksPage />} />
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
